export default __webpack_public_path__ + "static/media/not-found.ffdad94d.svg";